// src/utils/filenameUtils.ts

export const sanitizeFileName = (text: string): string => {
  return text
    .normalize("NFD") // Rozbija znaki diakrytyczne (np. ą => a + ogonek)
    .replace(/[\u0300-\u036f]/g, "") // Usuwa same ogonki
    .replace(/\s+/g, "_") // Zamienia spacje na _
    .replace(/[^a-zA-Z0-9_-]/g, "") // Usuwa wszystko co nie jest literą, cyfrą, _ lub -
    .toLowerCase();
};

export const generatePdfName = (fullName: string, category: string = "szablon"): string => {
  const date = new Date().toISOString().split("T")[0]; // Format YYYY-MM-DD
  const safeName = sanitizeFileName(fullName);
  const safeCategory = sanitizeFileName(category);
  
  // Wynik: 2024-05-20_jan_kowalski_basnie
  return `${date}_${safeName}_${safeCategory}`;
};